import { Serializable } from './Serializable';

export class ResourcesDTO extends Serializable {
    id: string;
    title: string;
    description: string;
    resourceURL: string;
    thumbnail: string;
    resourceType: number;
    resourceTypeName: string;
    resourceLevel: number;
    resourceLevelName: string;
    resourceCategoryID: string;
    resourceCategoryName: string;
    clientID: string;
    keyDriverID: string;
    keyDriverName: string;
    canAdministrate: boolean;
    
    constructor() {
        super();
    }
    
    isGlobal(): boolean {
        return this.clientID == null;
    }

}
